import React from 'react';

export default function ResumeRightSideLine(props) {    
    return (
        <div className="resume-right-side-line">
             { props.text }
        </div>
    );
}